// extracted by mini-css-extract-plugin
export var content = "partners-module--content--1aa68";
export var list = "partners-module--list--261eb";
export var logo = "partners-module--logo--281d8";
export var section = "partners-module--section--cb923";